export default "__VITE_ASSET__7Zn3BE33__";